<template>
  <div>
    <div @click="back" class="header">
      <i class="iconfont">&#xe604;</i>
    </div>
    <div class="content">
      <div class="select">
        <div class="left">
          <span>新手机号码</span>
        </div>
        <div class="right">
          <input type="text" placeholder="请输入手机号码" v-model="phone">
        </div>
      </div>
      <div class="select">
        <div class="left">
          <span>验证码</span>
        </div>
        <div class="right">
          <input class="auth_input" type="text" placeholder="请输入验证码" />
          <span v-show="sendAuthCode" class="btn"  @click="getAuthCode">获取验证码</span>
          <span v-show="!sendAuthCode" class="btn"> <span>{{auth_time}} </span> 秒后再获取</span>
        </div>
      </div>
    </div>
    <div class="footer">
      <router-link tag="button" to="/me">完成</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangetelMess',
  data () {
    return {
      sendAuthCode: true,
      auth_time: 0,
      phone: ''
    }
  },
  methods: {
    back () {
      this.$router.go(-1) // 返回上一层
    },
    getAuthCode () {
      if (!this.phone) {
        alert('请输入手机号')
      } else if (this.phone.length !== 11) {
        alert('请输入11位手机号')
      } else {
        this.sendAuthCode = false
        this.auth_time = 60
        var timer = setInterval(() => {
          this.auth_time--
          if (this.auth_time <= 0) {
            this.sendAuthCode = true
            clearInterval(timer)
          }
        }, 1000)
      }
    }
  }
}
</script>

<style scoped>
.header{ padding: 10px 15px; padding-bottom: 30px;}
.header .iconfont{ font-size: 25px;}
.content{ padding: 0 15px;}
.content .btn{ background-color: #fff; border: 1px solid #f6a975; color: #f6a975; border-radius: 3px; font-family: Arial,"Microsoft YaHei"; float: right; display: block; padding: 8px;}
.select{ display: flex; align-items: center; margin-bottom: 10px;}
.select input{ padding: 10px 0; width: 50%;}
input::-webkit-input-placeholder{ color:#b6b6b6; padding: 5px; font-size: 14px; line-height: 5px; font-family: Arial,"Microsoft YaHei";}
.content p{ color: #b8b8b8; font-size: 12px;}
.left{ width: 22%;}
.right{ width: 78%; border-bottom: 1px solid #dcdcdc;}
.footer{ padding: 15px 0;}
.footer button{ width: 80%; margin-right: auto; margin-left: auto; background-color: #ed2727; color: #fff; display: block; border: 0; height: 33px; border-radius: 3px; font-size: 14px; font-family: Arial,"Microsoft YaHei";}
</style>



// WEBPACK FOOTER //
// src/pages/change_tel/components/Mess.vue